import React from 'react';
import { MapIcon, LayersIcon, FileTextIcon, FilterIcon, ListChecksIcon, PrinterIcon } from 'lucide-react';
import { toolkit } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
const icons = [MapIcon, LayersIcon, FileTextIcon, FilterIcon, ListChecksIcon, PrinterIcon];
export function Toolkit() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-376" data-mp="avpyx7ruwkl5">
      <div className="mx-auto max-w-5xl px-4" data-id="element-377" data-mp="auezfk5g1yzu">
        <SectionHeading eyebrow="Your Complete Third Molar Assessment Toolkit" title="The Six Volumes Are Only the Beginning" intro="I’ve also included practical resources designed to make the Third Molar Assessment Blueprint™ framework easier to navigate and use." data-id="element-378" data-mp="5wn56jhbu0sh" />

        <ul className="mt-10 grid gap-x-10 sm:grid-cols-2" data-id="element-379" data-mp="2mkzb2djn53a1">
          {toolkit.map((t, i) => {
          const Icon = icons[i];
          return <li key={t.title} className="flex items-start gap-4 border-b border-line py-5" data-id="element-380" data-mp="2ho0kg4z6regl" data-mpi={i}>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-accentSoft text-accent" data-id="element-381" data-mp="201s0g64m3gg6">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-382" data-mp="23zpubm9buqpw" />
                </span>
                <div data-id="element-383" data-mp="28zkivj5mr47s">
                  <h3 className="text-base font-bold text-ink" data-id="element-384" data-mp="28z2dnx0zpfnq">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-muted" data-id="element-385" data-mp="2dswxd0glhumt">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-muted" data-id="element-386" data-mp="2noqhp60k2sf5">
          Any clinical terminology, assessment criteria, and reference material included in the final product should be checked against
          current professional sources before publication.
        </p>

        <div className="mt-10" data-id="element-387" data-mp="xef4b1qdw6vv">
          <CtaButton label="Get Access to All 6 Volumes" data-id="element-388" data-mp="xf6shrhnj2c4" />
        </div>
      </div>
    </section>;
}